import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, InputGroup, H3,H4,Switch, NumericInput } from '@blueprintjs/core';
import { withTranslation } from 'react-i18next';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';

class ImportParams extends React.PureComponent {
  
  handleBoolToTextChange = (e) => {
    const name = e.target.name;

    // console.log(`in handleBoolToTextChange, ${name} new value: ${!this.props.values[name]}`);

    const newBoolValue = !this.props.values[name];
    const newIntValue = newBoolValue ? 1 : 0;
    this.props.onValueChange('importParamValues', name, newIntValue);
  }

  // bizarrement pour les champs textes il faut utiliser un autre mécanisme de validation
  handleIdSentPatternChange = (e) => {
    const newValue = e.target.value;
    this.props.onValueChange('importParamValues', 'idSentPattern', newValue);
  }
  handleTimeIntPatternChange = (e) => {
    const newValue = e.target.value;
    this.props.onValueChange('importParamValues', 'timeIntPattern', newValue);
  }
  handleSpeakerPatternChange = (e) => {
    const newValue = e.target.value;
    this.props.onValueChange('importParamValues', 'speakerPattern', newValue);
  }

  handleSingleSelectChange = (e) => {
    const { name, value } = e.target;
    this.props.onValueChange('occurrencesParamValues', name, value);
  }

  render() {

    const {
        idSentPattern,
        timeIntPattern,
        speakerPattern,
        maxSpanSize,
        TTRSpanSize,
        csvDelimiter,
        metadataFormat,

    } = this.props.values;
    
    const { onValueChange,t } = this.props;
    const extractPatterns = this.props.values.extractPatterns ? true : false;
    const extractLexicometry = this.props.values.extractLexicometry ? true : false;
    const useLemma4Repet = this.props.values.useLemma4Repet ? true : false;
    const supprUnderScore = this.props.values.supprUnderScore ? true : false;


    const formGroupStyle = {
      display: 'flex',
      justifyContent: 'space-between',
    };

    return (
      <>
        <H3><u>{t('importParams')}</u></H3> 
        <br/>
        
        <H4><u>{t('extractionDefinition')}</u></H4>

        <Switch
          checked={extractPatterns}
          name="extractPatterns"
          label={t('extractPatterns')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />

        <Switch
          checked={extractLexicometry}
          name="extractLexicometry"
          label={t('extractLexicometry')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />

        <H4><u>{t('conllMetadataDefinition')}</u></H4>        

        <FormGroup
          helperText={t('idSentPattern')}
          label={t('idSentPattern')}
          inline={true}
          style={formGroupStyle}
        >
          <InputGroup
            value={idSentPattern}
            onChange={this.handleIdSentPatternChange}
          />
        </FormGroup>

        <FormGroup
          helperText={t('timeIntPattern')}
          label={t('timeIntPattern')}
          inline={true}
          style={formGroupStyle}
        >
          <InputGroup
            value={timeIntPattern}
            onChange={this.handleTimeIntPatternChange}
          />
        </FormGroup>

        <FormGroup
          helperText={t('speakerPattern')}
          label={t('speakerPattern')}
          inline={true}
          style={formGroupStyle}
        >
          <InputGroup
            value={speakerPattern}
            onChange={this.handleSpeakerPatternChange}
          />
        </FormGroup>

        <H4><u>{t('repetitionDefinition')}</u></H4>        

        <FormGroup
          label={t('maxSpanSize')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={10} buttonPosition={null}
            value={maxSpanSize}
            onValueChange={(newValue) => onValueChange('importParamValues', 'maxSpanSize', newValue)}
          />
        </FormGroup>

        <FormGroup
          label={t('TTRSpanSize')}
          inline={true}
          style={formGroupStyle}
        >
          <NumericInput
            min={10} buttonPosition={null}
            value={TTRSpanSize}
            onValueChange={(newValue) => onValueChange('importParamValues', 'TTRSpanSize', newValue)}
          />
        </FormGroup>

        <Switch
          checked={useLemma4Repet}
          name="useLemma4Repet"
          label={t('useLemma4Repet')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />

        <H4><u>{t('lemmaFormatDefinition')}</u></H4> 
        
        <Switch
          checked={supprUnderScore}
          name="supprUnderScore"
          label={t('supprUnderScore')}
          alignIndicator='right'
          onChange={this.handleBoolToTextChange}
        />
       
        <br/>
        <H3><u>{t('exportParams')}</u></H3> 
        <br/>

        <H4><u>{t('CSV')}</u></H4>        

        <FormGroup
          label={t('csvDelimiter')}
          inline={true}
          style={formGroupStyle}
        >
          <EnhancedSingleSelect
            options={[",",";","tabulation"]}
            name='csvDelimiter'
            value={csvDelimiter}
            onChange={this.handleSingleSelectChange}
            popoverProps={{ minimal: true }}
          />
        </FormGroup>

        <H4><u>{t('metadataFormatInConcord')}</u></H4>        

        <FormGroup
          helperText={t('eachMetadataShouldBeMarkedByBraces')}
          label={t('metadataFormat')}
          inline={true}
          style={formGroupStyle}
        >
          <InputGroup
            defaultValue={metadataFormat}
            type='text'
            onChange={(e) => this.props.onValueChange('importParamValues', 'metadataFormat', e.target.value)}
          />
        </FormGroup>

      </>
    );
  }
}

ImportParams.propTypes = {
  values: PropTypes.shape({
    extractPatterns: PropTypes.number,
    extractLexicometry: PropTypes.number,
    idSentPattern: PropTypes.string,
    timeIntPattern: PropTypes.string,
    speakerPattern: PropTypes.string,
    maxSpanSize: PropTypes.number,
    TTRSpanSize: PropTypes.number,
    useLemma4Repet: PropTypes.number,
    supprUnderScore: PropTypes.number,
    metadataFormat: PropTypes.string,
    csvDelimiter: PropTypes.string,
  }),
  onValueChange: PropTypes.func,
};

export default withTranslation()(ImportParams);